import { SalesChannel } from "client/lib/apt-merchant";
import { CountryList } from "client/lib/apt-merchant";

const eligibleChannels: SalesChannel[] = ["Online and In-store"];
const eligibleCountries: CountryList[] = [
  "Australia",
  "New Zealand",
  "United Kingdom",
  "United States",
];

type Args = { salesChannel?: SalesChannel; registeredCountry?: CountryList };

export const determineSecondBankFormEligibility = ({
  salesChannel,
  registeredCountry,
}: Args): boolean =>
  typeof registeredCountry !== "undefined" &&
  typeof salesChannel !== "undefined" &&
  eligibleCountries.includes(registeredCountry) &&
  eligibleChannels.includes(salesChannel);

export const confirmAccountNumberError =
  "Confirm that the two account numbers match";

export const determineCanadaChequingApplicability = (
  registeredCountry?: CountryList
): boolean => {
  if (registeredCountry === "Canada") {
    return true;
  }
  return false;
};

export const determineAccountApplicability = (
  registeredCountry?: CountryList
): boolean => {
  if (
    registeredCountry === "United States" ||
    registeredCountry === "Australia" ||
    registeredCountry === "United Kingdom" ||
    registeredCountry === "New Zealand"
  ) {
    return true;
  }
  return false;
};
